import { CustomerAccountsService } from "./CustomerAccountService";
import { CustomerAccount } from "../types/CustomerAccount";
import { CustomerV1DomainRelationshipList } from "src/app/api/infonova/models/CustomerV1DomainRelationshipList";
import {CustomersCustomerAccounts} from "./CustomersCustomerAccounts";
import { PartyOrganization } from "../types/PartyOrganization";
import { CustomerV1AccountList } from "../types/CustomerAccountsList";
import { Pagination } from "../types/Pagination";

export class CustomerAccountServiceImpl implements CustomerAccountsService {

    constructor(private api: CustomersCustomerAccounts) {
        
    }

    getCustomerAccount(id: string): Promise<CustomerAccount> {
        return this.api.getCustomerAccount(id);
    }

    getCustomerAccounts(pagination?: Pagination): Promise<CustomerV1AccountList> {
        return this.api.getCustomerAccounts(pagination);
    }

    getCustomerAccountRelationships(id: string): Promise<CustomerV1DomainRelationshipList> {
        return this.api.getCustomerAccountRelationships(id);
    }

    getPartyOrganization(id: string): Promise<PartyOrganization> {
        return this.api.getPartyOrganization(id);
    }

}